import type { CrmOpportunitySearchResultDto } from '../../features/opportunities/models/crm-opportunity.models';

const MOCK_CRM_HELVETIA = 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa';

const MOCK_CRM_OPPORTUNITY_ALPHA = 'eeeeeeee-eeee-eeee-eeee-eeeeeeeeeeee';

interface MockCrmOpportunityRow extends CrmOpportunitySearchResultDto {
  cNumber: string;
  crmProjectId: string;
}

const MOCK_CRM_OPPORTUNITIES: MockCrmOpportunityRow[] = [
  {
    opportunityId: MOCK_CRM_OPPORTUNITY_ALPHA,
    name: 'Helvetia Cloud Migration',
    cNumber: 'C-28471',
    crmProjectId: 'dddddddd-dddd-dddd-dddd-dddddddddddd',
  },
];

export function mockListCrmOpportunitiesByAccount(
  crmAccountId: string,
): CrmOpportunitySearchResultDto[] {
  if (crmAccountId !== MOCK_CRM_HELVETIA) {
    return [];
  }
  return MOCK_CRM_OPPORTUNITIES.map(({ opportunityId, name }) => ({ opportunityId, name }));
}

export function mockFindCrmOpportunityLink(
  crmOpportunityId: string,
): Pick<MockCrmOpportunityRow, 'opportunityId' | 'name' | 'cNumber' | 'crmProjectId'> | null {
  return MOCK_CRM_OPPORTUNITIES.find((row) => row.opportunityId === crmOpportunityId) ?? null;
}

export { MOCK_CRM_HELVETIA, MOCK_CRM_OPPORTUNITY_ALPHA };
